import * as angular from 'angular';
import * as _ from 'lodash';

export default (ngModule) => {
  ngModule
    .directive('scrollToTop', function scrollToTop($compile) {
      return {
        restrict: 'A',
        link: link
      };

      function link(scope, elem: JQuery) {

        let template = `
          <md-button class="md-warn md-hue-2 md-fab md-mini md-fab-bottom-right md-whiteframe-z2"
                     aria-label="Mover o scroll para o início">
            <i class="icon ion-chevron-up" style="font-size: 30px"></i>
          </md-button>
        `;

        let button = $compile(angular.element(template))(scope);
        elem.after(button);

        handler();

        elem.on('scroll', _.debounce(handler, 300));
        scope.$on('$destroy', () => elem.off('scroll', handler));

        button.on('click', scroll);
        scope.$on('$destroy', () => button.off('click', scroll));

        function handler() {
          button.css('display', elem[0].scrollTop > 100 ? 'block' : 'none');
        }

        function scroll() {
          elem[0].scrollTop = 0;
          button.css('display', 'none');
        }
      }
    });
};



/** WEBPACK FOOTER **
 ** ./common/decorators/scroll-to-top.directive.ts
 **/